import React from 'react';
import SoterTaskOverviewContainer from './SoterTaskOverviewContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const SoterTaskOverview = () => {
  return <SoterTaskOverviewContainer />;
};

export default PrivatePageHOC(SoterTaskOverview);
